export default __webpack_public_path__ + "static/media/IMG_5321.df94640c.WEBP";